import { AxiosInstance } from 'axios';
import { HttpCore } from './HttpCore';

/**
 * Base for the per-domain HTTP API classes. Each one is handed the client's
 * shared HttpCore, so they all send through the same axios instance and
 * therefore the same bearer token and interceptors.
 */
export abstract class HttpApi {
  constructor(protected readonly core: HttpCore) {}

  protected get http(): AxiosInstance {
    return this.core.http;
  }
}
